<template>
  <component :is="layout">
    <router-view v-slot="{ Component, route: slotRoute }">
      <component :is="Component" :key="slotRoute.path" />
    </router-view>
  </component>
  
  <!-- Global Toast Notifications -->
  <GlobalToast />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import DefaultLayout from './components/Layout.vue';
import GlobalToast from './components/GlobalToast.vue';

const route = useRoute();
const layout = computed(() => {
  if (route.meta.requiresAuth === false) {
    return 'div';
  }
  // Default to Layout for all other pages
  return route.name ? DefaultLayout : 'div';
});
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
